const CONFIG_URL = "/customizer/projects/";

export async function loadProjectConfig(projectId) {
  const url = `${CONFIG_URL}${projectId}/config.json`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load project config: ${url} (${response.status})`);
  }
  return response.json();
}

export function getProjectId() {
  const params = new URLSearchParams(window.location.search);
  return params.get("id");
}